import QRCode from "react-qr-code";

import { TintedButton } from "@shared/designSystem/Button";
import { SystemIcon } from "@shared/designSystem/SystemIcon";
import { SmallText } from "@shared/designSystem/Texts";
import designSystemStyles from "@shared/styles/designSystemStyles";

import styles from "./QRTile.module.css";

export type QRTileState = "ready" | "loading" | "error";

interface QRTileProps {
    value: string;
    state: QRTileState;
    onRetry: () => void;
    qrRef: React.RefObject<HTMLDivElement>;
}

export const QRTile: React.FC<QRTileProps> = ({ value, state, onRetry, qrRef }) => (
    <div ref={qrRef} className={styles.tile} style={{ boxShadow: designSystemStyles.shadowCard }}>
        {state === "ready" && <QRCode value={value} size={200} />}
        {state === "loading" && <div className={styles.skeleton} />}
        {state === "error" && (
            <div className={styles.error}>
                <SystemIcon type="warning-triangle" color={designSystemStyles.colorError} />
                <SmallText
                    text={"No se pudo generar el código".localized()}
                    color={designSystemStyles.colorTextSecondary}
                    alignment="center"
                />
                <TintedButton
                    text={"Reintentar".localized()}
                    onClick={onRetry}
                    width="140px"
                    height="40px"
                />
            </div>
        )}
    </div>
);

export default QRTile;
